
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 36.667c9.205 0 16.667-7.462 16.667-16.667 0-9.205-7.462-16.667-16.667-16.667-9.205 0-16.667 7.462-16.667 16.667 0 9.205 7.462 16.667 16.667 16.667zm6.178-22.846c.651.651.651 1.707 0 2.357L22.357 20l3.822 3.821a1.667 1.667 0 11-2.357 2.357L20 22.357l-3.822 3.821a1.667 1.667 0 11-2.357-2.357L17.643 20l-3.822-3.822a1.667 1.667 0 112.357-2.357L20 17.643l3.822-3.822c.65-.65 1.706-.65 2.357 0z","fill":"#313131"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      